export default __webpack_public_path__ + "static/APP_3_3_3-3919a2a348354d45ead40c524735d975.png";